import { mapActions, mapGetters, mapMutations } from 'vuex'
import { every, map, snakeCase, some, sumBy } from 'lodash'
import deliveryNovaPoshta from '../../components/delivery-nova-poshta/index.vue'
import deliveryNovaPoshtaCourier from '../../components/delivery-nova-poshta-courier/index.vue'
import deliveryNovaPoshtaCompany from '@/modules/buy-flow/components/delivery-nova-poshta-company/index.vue'
import DeliveryCompanyCourier from '@/modules/buy-flow/components/delivery-company-courier/index.vue'
import deliveryZasilkovna from '@/modules/buy-flow/components/delivery-zasilkovna/index.vue'
import DeliveryZasilkovnaBoxes from '@/modules/buy-flow/components/delivery-zasilkovna-boxes/index.vue'
import DeliveryCarrier from '@/modules/buy-flow/components/delivery-carrier/index.vue'
import { email, maxLength, minLength, required } from 'vuelidate/lib/validators'
import validation from '@/mixins/validation'
import PhoneMaskInput from 'vue-phone-mask-input'
import { debounce } from 'lodash'
import intlTelInput from 'intl-tel-input'
import { TheMask } from 'vue-the-mask'
import { countryMasks } from '../../../../helpers/helpers'
// HELPERS
import { isIPad, isMobile } from '@/helpers/variables'
import { makeid } from '../../../../helpers/helpers'
import { getProductPriceTitle, resolveProductImage, routeToProduct } from '@/helpers'
import country from '../../../../store/modules/country'
import CountryPhoneInput from '@/components/countryPhoneInput/index.vue'

const DeliveryType = {
  PICKUP: 'pickup',
  STORAGE: 'storage',
  ADDRESS: 'address',
  COURIER: 'courier',
  COURIER_PRAHA: 'praha_courier',
  CARRIER: 'carrier',
  ZBOX: 'zbox',
}

const PaymentProcessType = {
  CARD_ONLINE: 'card_online',
  PAY_WITH_DETAILS: 'pay_with_details',
  ELECTRONIC: 'electronic',
}

const RecipientType = {
  ME: 0,
  ANOTHER: 1,
}

export const OrderType = {
  TRANSFER: 'transfer', // storage
  CLIENTSALE: 'clientsale',
  SALE: 'sale',
}

const organizationValidations = {
  organizationData: {
    organisation_ico: { required },
  },
}

export default {
  name: 'order',

  mixins: [validation],
  components: {
    CountryPhoneInput,
    deliveryNovaPoshta,
    deliveryNovaPoshtaCourier,
    deliveryNovaPoshtaCompany,
    deliveryZasilkovna,
    DeliveryZasilkovnaBoxes,
    DeliveryCompanyCourier,
    DeliveryCarrier,
    PhoneMaskInput,
    TheMask,
  },
  data() {
    const storedCountry = localStorage.getItem('country').toLowerCase() || 'cz'
    const initialCountry = storedCountry in countryMasks ? storedCountry : 'cz'

    return {
      DeliveryType,
      RecipientType,
      OrderType,
      phoneMask: countryMasks[initialCountry],
      selectedCountry: initialCountry,
      iti: null,
      currentPlaceholder: '',
      orderTypes: [
        {
          id: OrderType.TRANSFER,
          title: this.$t('warehouse'),
        },
        {
          id: OrderType.SALE,
          title: this.$t('expenditureInvoice'),
        },
      ],
      syncBasketResponse: null,
      isPriceLoading: false,
      showBonusesInput: false,
      bonusesAmount: 0,
      liqpay: '',
      isAuth: localStorage.getItem('user_token'),
      recipientPhoneError: false,
      recipientNameError: false,
      recipientSecondNameError: false,
      disabled: false,
      selectedAddressFromList: false,
      goes_to_patient: false,
      phoneNumber: '',
      selectedDelivery: {
        id: 1,
        type: DeliveryType.PICKUP,
        unableCountries: [],
      },
      hidePromocod: true,
      selectedPayment: {},
      do_not_callback: false,
      selectedRecipient: {
        id: RecipientType.ME,
      },
      zasilkovna: {
        country: null,
        carrierRef: null,
        cityRef: null,
        storeRef: null,
      },

      recipientList: [
        {
          id: RecipientType.ME,
          title: this.$t('me'),
        },
        {
          id: RecipientType.ANOTHER,
          title: this.$t('anotherPerson'),
        },
      ],
      deliveryTown: true,
      deliveryDepartment: true,
      certificateFlag: false,
      selectedCertificate: '',
      payload: {
        recipientName: '',
        recipientPhone: '',
        recipientSecondName: '',
      },
      info: {
        name: '',
        lastName: '',
        phone: '',
        email: '',
        additionalInformation: '',
        // recipientFirstName: '',
        // recipientLastName: '',
        // recipientPhone: '',
      },
      organization: false,
      organizationData: {
        organisation_vat_number: '',
        organisation_ico: '',
      },
      // sale type if default for all orders
      selectedDocument: OrderType.SALE,
      randomHash: '',
      loadingPromoCode: false,
      promocode: '',
      promocodeProducts: null,
      promocodeResponse: null,
      promocodeActivated: false,
      promotionProducts: null,
      promotionResponse: null,
      validationErrors: {},
    }
  },
  validations() {
    if (this.organization) {
      if (this.selectedDelivery.type === DeliveryType.CARRIER) {
        return {
          ...organizationValidations,
          info: {
            name: {
              required,
            },
            lastName: {
              required,
            },
            phone: {
              required,
            },
            email: {
              email,
              required,
            },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.COURIER_PRAHA) {
        return {
          ...organizationValidations,
          info: {
            name: {
              required,
            },
            lastName: {
              required,
            },
            phone: {
              required,
            },
            email: {
              email,
              required,
            },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.PICKUP) {
        return {
          ...organizationValidations,
          info: {
            name: {
              required,
            },
            lastName: {
              required,
            },
            phone: {
              required,
            },
            email: {
              email,
              required,
            },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.ADDRESS && this.isAuthenticated) {
        return {
          ...organizationValidations,
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { email, required },
          },
          payload: {
            id: { required },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.ADDRESS && !this.isAuthenticated) {
        return {
          ...organizationValidations,
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { required, email },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.STORAGE) {
        return {
          ...organizationValidations,
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { required, email },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.ZBOX) {
        return {
          ...organizationValidations,
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { required, email },
          },
        }
      }
      if (
        this.selectedDelivery.type === DeliveryType.ADDRESS ||
        this.selectedDelivery.type === DeliveryType.COURIER ||
        this.selectedDelivery.type === DeliveryType.COURIER_PRAHA ||
        this.selectedDelivery.type === DeliveryType.CARRIER
      ) {
        return {
          ...organizationValidations,
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { required, email },
          },
        }
      }
    } else {
      if (this.selectedDelivery.type === DeliveryType.CARRIER) {
        return {
          info: {
            name: {
              required,
            },
            lastName: {
              required,
            },
            phone: {
              required,
            },
            email: {
              email,
              required,
            },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.ZBOX) {
        return {
          info: {
            name: {
              required,
            },
            lastName: {
              required,
            },
            phone: {
              required,
            },
            email: {
              email,
              required,
            },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.COURIER_PRAHA) {
        return {
          info: {
            name: {
              required,
            },
            lastName: {
              required,
            },
            phone: {
              required,
            },
            email: {
              email,
              required,
            },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.PICKUP) {
        return {
          info: {
            name: {
              required,
            },
            lastName: {
              required,
            },
            phone: {
              required,
            },
            email: {
              email,
              required,
            },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.ADDRESS && this.isAuthenticated) {
        return {
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { email, required },
          },
          payload: {
            id: { required },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.ADDRESS && !this.isAuthenticated) {
        return {
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { required, email },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.STORAGE) {
        return {
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { required, email },
          },
        }
      }
      if (this.selectedDelivery.type === DeliveryType.ADDRESS || this.selectedDelivery.type === DeliveryType.COURIER) {
        return {
          info: {
            name: { required },
            lastName: { required },
            phone: { required },
            email: { required, email },
          },
        }
      }
    }
  },
  computed: {
    country() {
      return country
    },
    ...mapGetters({
      dataFromAddressesList: 'order/savedAddress',
      deliveryMethods: 'order/deliveryMethods',
      basket: 'basket/basket',
      user: 'profile/user',
      isAuthenticated: `auth/isAuthenticated`,
      addressNovaPoshta: `order/address`,
      deliveryAddresses: 'order/addresses',
      addressNovaPoshtaCourier: `order/addressCourier`,
      isDistributor: 'profile/isDistributor',
      isProfessional: 'profile/isProfessional',
      isUserWithCode: 'profile/isUserWithCode',
      canUseBonuses: 'profile/canUseBonuses',
      selectedBonuses: 'basket/selectedBonuses',
      //-----------------------------------------------------------------------------
      certificate: 'order/certificate',
      //-----------------------------------payment-----------------------------------
      invoiceResult: 'order/invoiceResult',
      isInvoiceLoading: 'order/isInvoiceLoading',
      transactionResult: 'order/transactionResult',
      isTransactionLoading: 'order/isTransactionLoading',
      orderResult: 'order/orderResult',
      savedAddress: 'order/savedAddress',
      loadingOrder: 'order/isLoading',
      //---------------------------------delivery-----------------------------------
      deliveryAddress: 'order/deliveryAddress',
      //---------------------------------remaining-----------------------------------
      orderCheckResult: 'order/orderCheckResult',
      //---------------------------------region----------------------------------
      currentRegionCurrency: 'regions/currentRegionCurrency',
      currentRegion: 'regions/currentRegion',
    }),
    welcomeDiscountText() {
      const response = this.promocodeActivated ? this.promocodeResponse : this.promotionResponse
      if (!response || !response.appliedDiscount) return null
      if (response.appliedDiscount.type === 'welcome') {
        return this.$t('welcomeDiscount').replace('{percent}', response.appliedDiscount.percent)
      }
      return null
    },
    displayTotalToPay() {
      let total = 0
      if (this.promocodeActivated) {
        total = this.promocodeResponse.order.totalAmount + this.getDeliveryPrice - this.bonusesAmount
      } else if (this.promotionResponse && this.promotionResponse.order && this.promotionResponse.order.totalAmount) {
        total = this.promotionResponse.order.totalAmount + this.getDeliveryPrice - this.bonusesAmount
      } else {
        total = this.getTotalToPay
      }
      if (isNaN(total)) {
        return 0
      }
      return total > 0 ? total.toFixed(2) : 0
    },
    selectedDeliveryCountry() {
      return this.deliveryAddress.countryRef || this.deliveryAddress.countryCode
    },
    isOtherRegion() {
      return localStorage.getItem('country') === 'OTHER'
    },
    isOnlyWebinars() {
      return every(this.basket, { type: 'webinar' })
    },
    isAwebinar() {
      return some(this.basket, (product) => product.type === 'webinar')
    },
    isOnlyProducts() {
      let isWebinar = some(this.basket, (product) => product.type === 'webinar')
      let isProduct = some(this.basket, (product) => product.type !== 'webinar')
      return !(isWebinar && !isProduct)
    },
    organisationDicErrors() {
      return this.computeErrors('organizationData', 'organisation_vat_number', {
        required: 'validationRequired',
      })
    },
    nameErrors() {
      return this.computeErrors('info', 'name', {
        required: 'validationRequired',
      })
    },
    phoneErrors() {
      return this.computeErrors('info', 'phone', {
        required: 'validationRequired',
      })
    },
    lastNameErrors() {
      return this.computeErrors('info', 'lastName', {
        required: 'validationRequired',
      })
    },
    emailErrors() {
      return this.computeErrors('info', 'email', {
        required: 'validationRequired',
        email: 'validationEmail',
      })
    },
    totalSum() {
      const bonusesAmount = this.bonusesAmount <= this.user?.bonusAmount ? this.selectedBonuses.pay_bonus_amount : 0

      const sum = this.basket.reduce((total, item) => {
        if (item.allProductSum / item.select_count === 0.01) {
          return total + item.allProductSum
        }
        const itemTotal = item.select_type.price * item.select_count
        console.log(item.select_type.price)
        return total + itemTotal
      }, 0)

      return sum - bonusesAmount
    },

    totalSumWithoutBonuses() {
      return sumBy(this.basket, (product) => product.select_type.price * product.select_count)
    },
    getTempDiscount() {
      return this.hasTempDiscount() ? (this.totalSum * 5) / 100 : 0
    },
    discount() {
      if (!this.canSeeDiscount()) {
        return 0
      }

      let sum = 0

      this.basket.forEach((basketProduct) => {
        const clientPrice = basketProduct.client_price

        // do not calculate for regular users
        if (!clientPrice) {
          return
        }

        let discount = 0

        const price = basketProduct.select_type
        if (this.isProfessional) {
          // for professionals calculate only individual discount
          if (price.hasIndividualDiscount) {
            discount = price.oldPrice - price.price
          }
        } else if (this.isDistributor) {
          // discount = professional price - distributor price
          discount = clientPrice.price - price.price
        } else {
          // for users with code calc actual discount, without promotion percent
          if (clientPrice.hasActivePromotion) {
            discount = clientPrice.oldPrice - price.oldPrice
          } else {
            discount = clientPrice.price - price.price
          }
        }

        sum += discount * basketProduct.select_count
      })

      return sum
    },
    getDeliveryPrice() {
      const { price, type, freeAfter } = this.selectedDelivery
      const deliveryPrice = parseInt(price)
      if (type === DeliveryType.PICKUP) return 0
      if (freeAfter !== 0 && freeAfter !== null && this.totalSum >= freeAfter) return 0
      return deliveryPrice
    },
    getTotalToPay() {
      const hasFreeDelivery =
        this.selectedDelivery.type === DeliveryType.PICKUP ||
        (this.selectedDelivery.freeAfter !== 0 && this.totalSum >= this.selectedDelivery.freeAfter)

      let deliveryPrice = hasFreeDelivery ? 0 : Number(this.selectedDelivery.price).toFixed(2)

      let certValue = 0
      if (this.certificate) {
        certValue = Math.min(this.certificate.discount, this.totalSum)
      }

      const total = this.totalSum - certValue + deliveryPrice
      return Number(total).toFixed(2)
    },
    getDeliveryPriceNumber() {
      const hasFreeDelivery =
        this.selectedDelivery.type === DeliveryType.PICKUP ||
        (this.selectedDelivery.freeAfter !== 0 && this.totalSum >= this.selectedDelivery.freeAfter)

      return hasFreeDelivery ? 0 : Number(this.selectedDelivery.price).toFixed(2)
    },
    getTotalToPayWithoutDelivery() {
      let certValue = 0
      if (this.certificate) {
        certValue = Math.min(this.certificate.discount, this.totalSum)
      }
      return this.totalSum - certValue
    },
  },
  mounted() {
    if (!this.$refs.phoneInput) return
    const phoneInput = this.$refs.phoneInput.$el
    const utilsScript = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.5.7/js/utils.js'

    if (!window.intlTelInputUtils) {
      const script = document.createElement('script')
      script.src = utilsScript
      script.onload = () => this.initPhoneInput(phoneInput)
      document.body.appendChild(script)
    } else {
      this.initPhoneInput(phoneInput)
    }
  },
  watch: {
    bonusesAmount() {
      this.setBonuses({ pay_bonus_amount: this.bonusesAmount })
      this.$refs.bonusesError.innerHTML = ''
      this.disabledButton = false

      if (this.bonusesAmount > this.user?.bonusAmount) {
        this.$refs.bonusesError.innerHTML = `${this.$t('available')}  ${this.user.bonusAmount} ${this.$t('bonuses')}`
        this.disabledButton = true
      }
    },
    selectedDelivery() {
      this.resetSelectedAddress()
      this.checkSelectedDeliveryChecked()
      this.selectedAddressFromList = false
      this.changeSelectedPayment(this.selectedDocument)
    },
    dataFromAddressesList() {
      this.selectedAddressFromList = !!(this.dataFromAddressesList.guid && this.isAuthenticated)
    },
    user() {
      this.setUserInfo()

      this.hidePromocod = false

      if (this.isDistributor) {
        this.selectedDocument = OrderType.TRANSFER
      }
    },
    'addressNovaPoshta.town': function () {
      if (this.addressNovaPoshta.town.length) {
        this.deliveryTown = true
      }
    },
    transactionResult: function () {
      this.liqpay = this.transactionResult
    },
    'payload.recipientName': function () {
      if (this.payload.recipientName.length > 0) {
        this.$refs.recipientName.textContent = ''
        this.recipientNameError = false
      }
    },
    'payload.recipientPhone': function () {
      if (this.payload.recipientPhone.length > 0) {
        this.$refs.recipientPhone.textContent = ''
        this.recipientPhoneError = false
      }
    },
    'payload.recipientSecondName': function () {
      if (this.payload.recipientSecondName.length > 0) {
        this.$refs.recipientSecondName.textContent = ''
        this.recipientSecondNameError = false
      }
    },
    'organizationData.edrpouCode': function (val, oldVal) {
      if (val.length > 0 && !val.match(/^\d+$/)) {
        this.organizationData.edrpouCode = oldVal
      }
    },
    $route(newVal) {
      if (newVal) {
        if (!this.user && this.isAuthenticated) {
          this.fetchUser()
        }
        this.fetchDeliveryMethods().then(() => {
          this.selectedDelivery = this.deliveryMethods[0]
        })
      }
    },
    selectedDocument(val) {
      this.changeSelectedPayment(val)
    },
    organization() {
      this.organizationData.organisation_ico = this.user.icoNumber || ''
      this.organizationData.organisation_vat_number = this.user.vatNumber || ''
      this.clearUserInfoValidation()
    },
  },
  created() {
    this.resetCertificate()
    if (this.isAuthenticated && this.user) this.setUserInfo()
    this.fetchDeliveryMethods().then(() => {
      this.selectedDelivery = this.deliveryMethods[0]
    })
    this.randomHash = this.makeid(20)
    if (this.basket.length > 0) this.syncBasket()

    const transformedProducts = this.basket.map((item) => {
      return {
        item_id: item.select_type.article,
        item_name: item.title,
        affiliation: 'Renew-Cosmetics',
        coupon: '',
        discount: 0.0,
        index: 0,
        item_brand: item.brand?.data?.title || 'Renew',
        item_category: item.brandSeries?.data?.title || '',
        item_category2: (() => {
          if (!this.isAuthenticated) return 'unauthorized'
          if (this.isProfessional) return 'professional'
          if (this.isDistributor) return 'distributor'
          return 'regular'
        })(),
        item_list_id: 'Cosmetics',
        item_list_name: 'Cosmetics',
        location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
        price: Number(item.select_type.price).toFixed(2),
        quantity: item.select_count,
      }
    })

    const sum = this.basket.reduce((acc, item) => {
      return acc + item.select_type.price * item.select_count
    }, 0)

    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'begin_checkout',
      ecommerce: {
        currency: this.currentRegionCurrency || 'EUR',
        value: parseFloat(sum).toFixed(2),
        items: transformedProducts,
      },
    })
  },
  methods: {
    getProductPriceTitle,
    routeToProduct,
    resolveProductImage,
    makeid,
    ...mapActions({
      fetchAddress: 'order/GET_ADDRESS_LIST',
      fetchDeliveryMethods: 'order/GET_DELIVERY_METHODS',
      fetchUser: 'profile/FETCH_USER_DATA',
      createOrder: 'order/CREATE_ORDER',
      checkOrder: 'order/CHECK_ORDER',
      getSyncBasket: 'basket/GET_SYNC_BASKET',
      fetchPromotion: 'basket/FETCH_PROMOTION',
      fetchDefaultPrices: 'basket/GET_DEFAULT_PRICE_BASKET',
      fetchCertificate: 'order/GET_CERTIFICATE',
      createInvoice: 'order/CREATE_INVOICE',
      createTransaction: 'order/CREATE_TRANSACTION',
      fetchNewDeliveryPrice: 'order/FETCH_NEW_DELIVERY_PRICE',
      fetchPromocodeInfo: 'basket/FETCH_PROMOCODE_INFO',
      fetchZboxDeliveryCountries: 'order/FETCH_ZBOX_DELIVERY_COUNTRIES',
    }),
    ...mapMutations({
      setBonuses: 'basket/SET_USER_BONUSES',
      saveAddress: 'order/SAVE_SELECT_ADDRESS',
      changeAddressesListPopup: 'popups/CHANGE_ADDRESSES_LIST_POPUP',
      resetBasket: 'basket/RESET_BASKET',
      resetCertificate: 'order/CLEAR_CERTIFICATE',
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP',
      changeSuccessPayment: 'popups/CHANGE_SUCCESS_PAYMENT_POPUP',
      showRemainingsPopup: 'popups/CHANGE_REMAININGS_POPUP',
      increment: 'basket/INCREMENT_BASKET_LIST_COUNT',
      decrement: 'basket/DECREMENT_BASKET_LIST_COUNT',
      setCount: 'basket/SET_BASKET_LIST_COUNT',
      remove: 'basket/REMOVE_ITEM_FROM_BASKET',
      saveDeliveryAddress: 'order/SAVE_DELIVERY_ADDRESS',
    }),
    changePhone(value) {
      console.log('event => ', value)
      this.info.phone = value
    },
    changeRecipientPhone(value) {
      this.payload.recipientPhone = value
    },
    initPhoneInput(phoneInput) {
      this.iti = intlTelInput(phoneInput, {
        initialCountry: this.getInitialCountry(),
        separateDialCode: false,
        autoPlaceholder: 'off',
        utilsScript: '',
      })

      phoneInput.addEventListener('countrychange', () => {
        try {
          const countryData = this.iti.getSelectedCountryData()
          this.updateCountryData(countryData)
        } catch (e) {
          console.error('Country change error:', e)
          this.fallbackToCzech()
        }
      })

      this.currentPlaceholder = this.iti.getSelectedCountryData().placeholder
    },

    getInitialCountry() {
      const storedCountry = localStorage.getItem('country').toLowerCase() || 'cz'
      return countryMasks[storedCountry] ? storedCountry : 'cz'
    },

    updateCountryData(countryData) {
      if (countryData.iso2 !== undefined) {
        this.selectedCountry = countryData.iso2
        this.phoneMask = countryMasks[countryData.iso2] || countryMasks.cz
      }
    },

    fallbackToCzech() {
      this.selectedCountry = 'cz'
      this.phoneMask = countryMasks.cz
      if (this.iti) {
        this.iti.setCountry('cz')
      }
    },
    handlePhoneInput(event) {
      if (this.phoneNumber.startsWith('+')) {
        const countryCode = this.phoneNumber.replace(/\D/g, '').slice(0, 4)
        const country = this.iti.getCountryData().find((c) => c.dialCode === countryCode)
        if (country) {
          this.selectedCountry = country.iso2
          this.phoneMask = countryMasks[country.iso2] || countryMasks.cz
        }
      }
      this.info.phone = event.target.value
    },
    checkSelectedDeliveryChecked() {
      this.selectedPayment = {}
    },
    isSample(product) {
      return product.type === 'sampler' && product.allProductSum / product.select_count === 0.01
    },
    allowedProductManipulations(product) {
      return !product.isAddedFromSale && !this.isSample(product) && !product.isPresent
    },

    async handleRemove(item) {
      this.remove(item)
      if (this.basket.length > 0) {
        this.isPriceLoading = true
        await this.fetchOrderPromotion()
      }
    },

    async updateDeliveryPrice(e) {
      if(this.selectedDelivery.type === DeliveryType.ZBOX) return;
      let payload = {
        ...e,
      }
      payload['delivery'] = this.selectedDelivery.id
      payload['payment'] = this.selectedPayment.id
      payload['currency'] = this.currentRegionCurrency
      const response = await this.fetchNewDeliveryPrice(payload)
      if (response.value === 0 && response.message.length > 0) {
        this.selectedDelivery.showWithMessage = true
        this.selectedDelivery.message = response.message
        this.selectedDelivery.price = response.value
      } else {
        this.selectedDelivery.showWithMessage = false
        this.selectedDelivery.message = ''
        this.selectedDelivery.price = response.value
      }
    },

    findCurrentProductPromotionBanner(id) {
      if (!this.promotionResponse || !this.promotionResponse.closestSales) return null

      const promotion = this.promotionResponse.closestSales.find((promo) => promo.productPricesToApply.includes(id))

      return promotion || null
    },

    changeCount(type, product, count = 1) {
      if (type === 'increment') {
        this.increment(product)
      } else if (type === 'decrement') {
        this.decrement(product)
      } else {
        if (count) {
          this.setCount({
            product: product,
            select_count: parseInt(count),
          })
        }
      }
      this.isPriceLoading = true
      this.fetchOrderPromotion()
    },
    resetSelectedAddress() {
      this.saveAddress({})
    },
    setUserInfo() {
      this.info.name = this.user.name
      this.info.lastName = this.user.lastName || this.user.secondName
      this.info.email = this.user.email
      this.info.phone = this.user.phone.replace(/[^+\d]/g, '')

      if (this.user.icoNumber) {
        this.organization = true
        this.organizationData.organisation_ico = this.user.icoNumber || ''
        this.organizationData.organisation_vat_number = this.user.vatNumber || ''
      } else {
        this.organization = false
      }

      try {
        this.$refs.phoneInput.$el.value = this.user.phone.replace(/[^+\d]/g, '')
      } catch (e) {}
    },
    /**
     *
     * @param {DeliveryMethod|any} delivery
     * @return {boolean}
     */
    canSelectAddress(delivery) {
      const showAddressSelect = [
        DeliveryType.ADDRESS,
        DeliveryType.COURIER,
        DeliveryType.STORAGE,
        DeliveryType.COURIER_PRAHA,
        DeliveryType.CARRIER,
      ]
      return showAddressSelect.includes(delivery?.type)
    },
    /**
     * @param {DeliveryMethod} delivery
     */
    async selectDeliveryMethod(delivery) {
      this.selectedDelivery = delivery
      this.resetSelectedAddress()
      this.askUserAddress(delivery)
      if (this.selectedDelivery.type === DeliveryType.ZBOX) {
        this.selectedDelivery.countries = await this.fetchZboxDeliveryCountries();
      }
    },
    changeSelectedPayment(orderType) {
      if (!this.isDistributor) {
        this.selectedPayment = this.selectedDelivery.availablePaymentMethods[0]
      } else {
        if ([OrderType.CLIENTSALE, OrderType.SALE].includes(orderType)) {
          this.selectedPayment = this.selectedDelivery.availablePaymentMethods.find((method) => method.processType === 'pay_with_details')
        } else if (OrderType.TRANSFER === orderType) {
          this.selectedPayment = null
        }
      }
    },

    /**
     * @param {DeliveryMethod} delivery
     */
    askUserAddress(delivery) {
      // if (!this.canSelectAddress(delivery)) {
      //     return;
      // }
      //
      // if (!this.isAuthenticated) {
      //     return;
      // }
      // this.fetchAddress().then(() => {
      //     // BUG
      //     console.log('this.deliveryAddresses => ', this.deliveryAddresses);
      //     if (this.deliveryAddresses.length) {
      //         this.changeAddressesListPopup(true);
      //     }
      // });
    },
    checkCode(code) {
      this.fetchCertificate(code)
        .then(() => {
          this.$toasted.success(this.$t('promocodeActivate'))
          if (
            ((this.selectedDelivery.type === DeliveryType.STORAGE && this.totalSum >= 1500) ||
              (this.selectedDelivery.type === DeliveryType.ADDRESS && this.totalSum >= 3000) ||
              this.selectedDelivery.type === DeliveryType.PICKUP) &&
            this.certificate.discount === this.totalSum
          ) {
            this.certificateFlag = true
          } else {
            this.certificateFlag = false
          }
        })
        .catch(() => {
          this.$toasted.error(this.$t('errorPromocode'))
        })
    },
    async syncBasket() {
      console.log('syncBasket')
      this.isPriceLoading = true
      const ids = map(this.basket, 'id')
      await this.getSyncBasket({ ids: ids })
      await this.fetchDefaultPrices({ ids: ids })
      await this.fetchOrderPromotion()
    },
    async createInvoiceLocal() {
      try {
        await this.createInvoice({ order_id: this.orderResult.id })
        await this.createTransactionLocal()
      } catch (error) {
        throw error
      }
    },
    async createTransactionLocal() {
      try {
        await this.createTransaction({
          invoice_id: this.invoiceResult.id,
        })

        setTimeout(() => {
          document.getElementById('checkout-form').submit()
        }, 1500)
      } catch (error) {
        throw error
      }
    },
    clearUserInfoValidation() {
      const userInfo = document.querySelector('.order-contact__form')
      const inputs = userInfo.querySelectorAll('.input-col')
      inputs.forEach((item) => {
        if (item.classList.contains('error')) {
          item.classList.remove('error')
          item.classList.add('valid')
          const label = item.querySelector('span')
          label.innerHTML = ''
        }
      })
    },
    // recipient validation
    validateRecipient() {
      if (this.selectedRecipient.id === RecipientType.ME) this.submit()
      if (this.selectedRecipient.id === RecipientType.ANOTHER) this.validationRecipientData()
    },
    validationRecipientData() {
      this.validationPhone()
      this.validationName()
      this.validationSecondName()
      if (this.recipientPhoneError || this.recipientNameError || this.recipientSecondNameError) {
        return
      }
      this.submit()
    },
    validationPhone() {
      const error = this.$refs.recipientPhone
      const phoneLength = this.payload.recipientPhone.length
      error.textContent = ''

      if (phoneLength === 0) {
        error.append(this.$t('validationRequired'))
        this.recipientPhoneError = true
      }
    },
    validationName() {
      let error = this.$refs.recipientName
      let phone = this.payload.recipientName.length
      error.textContent = ''
      switch (true) {
        case phone === 0:
          error.append(this.$t('validationRequired'))
          this.recipientNameError = true
          break
        case phone < 2 && phone > 0:
          error.append(this.$t('validationMin').replace(':count', 2))
          this.recipientNameError = true
          break
      }
    },
    validationSecondName() {
      let error = this.$refs.recipientSecondName
      let phone = this.payload.recipientSecondName.length
      error.textContent = ''
      switch (true) {
        case phone === 0:
          error.append(this.$t('validationRequired'))
          this.recipientSecondNameError = true
          break
        case phone < 2 && phone > 0:
          error.append(this.$t('validationMin').replace(':count', 2))
          this.recipientSecondNameError = true
          break
      }
    },
    // delivery validations
    validateCarrierDelivery() {
      let countryErrorBlock = document.getElementById('countryError')
      let carrierErrorBlock = document.getElementById('carrierError')
      let pickupPointErrorBlock = document.getElementById('pickupPointError')

      if (!this.deliveryAddress.country) {
        countryErrorBlock.innerHTML = this.$t('validationRequired')
      } else {
        countryErrorBlock.innerHTML = ''
      }

      if (!this.deliveryAddress.carrier) {
        carrierErrorBlock.innerHTML = this.$t('validationRequired')
      } else {
        carrierErrorBlock.innerHTML = ''
      }

      if (!this.deliveryAddress.pickupPoint) {
        pickupPointErrorBlock.innerHTML = this.$t('validationRequired')
      } else {
        pickupPointErrorBlock.innerHTML = ''
      }

      if (this.deliveryAddress.country && this.deliveryAddress.carrier && this.deliveryAddress.pickupPoint) {
        countryErrorBlock.innerHTML = ''
        carrierErrorBlock.innerHTML = ''
        pickupPointErrorBlock.innerHTML = ''

        this.validateRecipient()
      }
    },
    validationCompanyCourier() {
      let departmentError = document.getElementById('addressError')
      let buildingError = document.getElementById('buildingError')
      let zipCodeErrorBlock = document.getElementById('zipCodeError')

      if (!this.selectedAddressFromList) {
        if (!this.deliveryAddress.department) {
          departmentError.innerHTML = this.$t('validationRequired')
        } else {
          departmentError.innerHTML = ''
        }
        if (!this.deliveryAddress.house) {
          buildingError.innerHTML = this.$t('validationRequired')
        } else {
          buildingError.innerHTML = ''
        }
        if (!this.deliveryAddress.zip || !this.deliveryAddress.zip.length) {
          zipCodeErrorBlock.innerHTML = this.$t('validationRequired')
        } else {
          zipCodeErrorBlock.innerHTML = ''
        }

        if (this.deliveryAddress.department && this.deliveryAddress.house) {
          departmentError.innerHTML = ''
          buildingError.innerHTML = ''
          zipCodeErrorBlock.innerHTML = ''

          this.validateRecipient()
        }
      }

      if (this.selectedAddressFromList) {
        this.validateRecipient()
      }
    },
    validationDepartmentCourier() {
      let countryErrorBlock = document.getElementById('countryError')
      let carrierErrorBlock = document.getElementById('carrierError')
      let cityErrorBlock = document.getElementById('cityError')
      let buildingErrorBlock = document.getElementById('buildingError')
      let zipCodeErrorBlock = document.getElementById('zipCodeError')
      let streetErrorBlock = document.getElementById('streetError')

      if (!this.selectedAddressFromList) {
        if (!this.deliveryAddress.country || !this.deliveryAddress.country.length) {
          countryErrorBlock.innerHTML = this.$t('validationRequired')
        } else {
          countryErrorBlock.innerHTML = ''
        }

        if (!this.deliveryAddress.carrier || !this.deliveryAddress.carrier.length) {
          carrierErrorBlock.innerHTML = this.$t('validationRequired')
        } else {
          carrierErrorBlock.innerHTML = ''
        }

        if (!this.deliveryAddress.city || !this.deliveryAddress.city.length) {
          cityErrorBlock.innerHTML = this.$t('validationRequired')
        } else {
          cityErrorBlock.innerHTML = ''
        }

        if (!this.deliveryAddress.house || !this.deliveryAddress.house.length) {
          buildingErrorBlock.innerHTML = this.$t('validationRequired')
        } else {
          buildingErrorBlock.innerHTML = ''
        }

        if (!this.deliveryAddress.zip || !this.deliveryAddress.zip.length) {
          zipCodeErrorBlock.innerHTML = this.$t('validationRequired')
        } else {
          zipCodeErrorBlock.innerHTML = ''
        }

        if (!this.deliveryAddress.street || !this.deliveryAddress.street.length) {
          streetErrorBlock.innerHTML = this.$t('validationRequired')
        } else {
          streetErrorBlock.innerHTML = ''
        }

        if (
          this.deliveryAddress.country &&
          this.deliveryAddress.carrier &&
          this.deliveryAddress.city &&
          this.deliveryAddress.house &&
          this.deliveryAddress.zip &&
          this.deliveryAddress.street
        ) {
          countryErrorBlock.innerHTML = ''
          carrierErrorBlock.innerHTML = ''
          cityErrorBlock.innerHTML = ''
          buildingErrorBlock.innerHTML = ''
          zipCodeErrorBlock.innerHTML = ''
          streetErrorBlock.innerHTML = ''
          this.validateRecipient()
        }
      }

      if (this.selectedAddressFromList) {
        this.validateRecipient()
      }
    },
    handleSelectZasilkovnaCity(payload) {
      this.saveDeliveryAddress({
        city: payload.name,
        carrier: this.zasilkovna.carrier,
        country: this.zasilkovna.country,
        countryRef: this.zasilkovna.countryRef,
      })
      this.zasilkovna.cityRef = payload.id
      let cityError = document.getElementById('cityError')
      cityError.innerHTML = ''
    },
    async handleSelectZasilkovnaCountry(payload) {
      this.saveDeliveryAddress({
        country: payload.name,
        countryRef: payload.alpha2Code,
      })
      this.zasilkovna.countryRef = payload.alpha2Code
      await this.updateDeliveryPrice({ country: payload.alpha2Code })
      let countryError = document.getElementById('countryError')
      countryError.innerHTML = ''
    },
    handleSelectZasilkovnaCarrier(payload) {
      this.saveDeliveryAddress({
        carrier: payload.name,
        country: this.zasilkovna.country,
        countryRef: this.zasilkovna.countryRef,
      })
      this.zasilkovna.carrierRef = payload.id
      let carrierError = document.getElementById('carrierError')
      carrierError.innerHTML = ''
    },
    handleSelectZasilkovnaBranch(department) {
      this.saveDeliveryAddress({
        carrier: this.zasilkovna.carrier,
        country: this.zasilkovna.country,
        countryRef: this.zasilkovna.countryRef,
        city: this.deliveryAddress.city,
        department: department.name,
      })
      this.zasilkovna.storeRef = department.id
      this.zasilkovna.deliveryStore = department.name
      let departmentError = document.getElementById('departmentError')
      departmentError.innerHTML = ''
    },
    validationDepartmentDelivery() {
      let cityError = document.getElementById('cityError')
      let countryError = document.getElementById('countryError')
      let departmentError = document.getElementById('departmentError')

      if (!this.selectedAddressFromList) {
        if (!this.deliveryAddress.city) {
          cityError.innerHTML = this.$t('validationRequired')
        }
        if (!this.deliveryAddress.country) {
          countryError.innerHTML = this.$t('validationRequired')
        }
        if (!this.deliveryAddress.department) {
          departmentError.innerHTML = this.$t('validationRequired')
        }

        if (this.deliveryAddress.city && this.deliveryAddress.department) {
          cityError.innerHTML = ''
          departmentError.innerHTML = ''
          countryError.innerHTML = ''

          this.validateRecipient()
        }
      }

      if (this.selectedAddressFromList) {
        this.validateRecipient()
      }

      // deliveryTown:true,
      //   deliveryDepartment:true,
      // if (this.addressNovaPoshta.town.length === 0) {
      //   this.deliveryTown = false
      // }
      // if (!this.addressNovaPoshta.department || this.addressNovaPoshta.department.length === 0) {
      //   this.deliveryDepartment = false
      // }
    },
    validateDeliveryMethod() {
      switch (this.selectedDelivery.type) {
        case DeliveryType.PICKUP:
          this.validateRecipient()
          break
        case DeliveryType.CARRIER:
          this.validateCarrierDelivery()
          break
        case DeliveryType.COURIER_PRAHA:
          if (this.savedAddress.address !== '') {
            this.validationCompanyCourier()
          } else {
            this.changeAddressesListPopup(true)
          }
          break
        case DeliveryType.COURIER:
          if (this.savedAddress.address !== '') {
            this.validationCompanyCourier()
          } else {
            this.changeAddressesListPopup(true)
          }
          break
        case DeliveryType.ADDRESS:
          if (this.savedAddress.address !== '') {
            this.validationDepartmentCourier()
          } else {
            this.changeAddressesListPopup(true)
          }
          break
        case DeliveryType.STORAGE:
          if (this.savedAddress.address !== '') {
            this.validationDepartmentDelivery()
          } else {
            this.changeAddressesListPopup(true)
          }
          break
        case DeliveryType.ZBOX:
          if (this.savedAddress.address !== '') {
            this.validationDepartmentDelivery()
          } else {
            this.changeAddressesListPopup(true)
          }
          break
      }
    },

    validateOrgModePaymentAndDelivery() {
      if (this.selectedRecipient.id === RecipientType.ANOTHER) {
        this.validationPhone()
        this.validationName()
        this.validationSecondName()
      }
      if (
        this.selectedPayment &&
        this.selectedPayment.type === 'online' &&
        this.selectedDelivery.type === DeliveryType.PICKUP &&
        this.selectedRecipient.id === 0
      )
        return true

      let deliveryError = false
      switch (this.selectedDelivery.type) {
        case DeliveryType.COURIER:
          if (this.savedAddress.address !== '') {
            let departmentError = document.getElementById('addressError')
            let buildingError = document.getElementById('buildingError')
            let flatError = document.getElementById('flatError')

            if (!this.selectedAddressFromList) {
              if (!this.deliveryAddress.department) {
                departmentError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }
              if (!this.deliveryAddress.house) {
                buildingError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }
              if (!this.deliveryAddress.flat) {
                flatError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }

              if (this.deliveryAddress.department && this.deliveryAddress.flat && this.deliveryAddress.house) {
                departmentError.innerHTML = ''
                buildingError.innerHTML = ''
                flatError.innerHTML = ''
              }
            }
          } else {
            this.changeAddressesListPopup(true)
          }
          break
        case DeliveryType.ADDRESS:
          if (this.savedAddress.address !== '') {
            let cityError = document.getElementById('courierCityError')
            let departmentError = document.getElementById('addressError')
            let buildingError = document.getElementById('buildingError')
            let flatError = document.getElementById('flatError')

            if (!this.selectedAddressFromList) {
              if (!this.deliveryAddress.city) {
                cityError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }
              if (!this.deliveryAddress.department) {
                departmentError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }
              if (!this.deliveryAddress.house) {
                buildingError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }
              if (!this.deliveryAddress.flat) {
                flatError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }

              if (this.deliveryAddress.city && this.deliveryAddress.department && this.deliveryAddress.house && this.deliveryAddress.flat) {
                cityError.innerHTML = ''
                departmentError.innerHTML = ''
                buildingError.innerHTML = ''
                flatError.innerHTML = ''
              }
            }
          } else {
            this.changeAddressesListPopup(true)
          }
          break
        case DeliveryType.STORAGE:
          if (this.savedAddress.address !== '') {
            let cityError = document.getElementById('cityError')
            let departmentError = document.getElementById('departmentError')

            if (!this.selectedAddressFromList) {
              if (!this.deliveryAddress.city) {
                cityError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }
              if (!this.deliveryAddress.department) {
                departmentError.innerHTML = this.$t('validationRequired')
                deliveryError = true
              }

              if (this.deliveryAddress.city && this.deliveryAddress.department) {
                cityError.innerHTML = ''
                departmentError.innerHTML = ''
              }
            }
          } else {
            this.changeAddressesListPopup(true)
          }
          break
      }
      return !(this.recipientPhoneError || this.recipientNameError || this.recipientSecondNameError || deliveryError)
    },

    checkCorrectInfo(field) {
      return this.$v[field] ? this.$v[field].$invalid === false || this.$v[field].$invalid === undefined : true
    },

    validateDistributor() {
      this.$v.$touch()
      let correct = false
      if (!this.checkCorrectInfo('info')) correct = true
      if (!this.checkCorrectInfo('organizationData')) correct = true

      if (this.selectedDocument === OrderType.TRANSFER) {
        if (this.validateOrgModePaymentAndDelivery()) correct = true
      }

      if (this.selectedDocument === OrderType.CLIENTSALE) {
        if (this.validateOrgModePaymentAndDelivery()) correct = true
      }

      if (this.selectedDocument === OrderType.SALE) {
        if (this.validateOrgModePaymentAndDelivery()) correct = true
      }
      if (correct) {
        this.submit()
      } else {
        console.log('Error')
      }
    },

    hasTempDiscount() {
      return this.user && this.user.tempDiscount
    },
    canSeeDiscount() {
      return this.user && (this.isUserWithCode || this.isProfessional || this.isDistributor)
    },
    /**
     * @param {DeliveryMethod} delivery
     * @return {string|null}
     */
    getTitleForDeliveryInList(delivery) {
      if (delivery.type === DeliveryType.PICKUP) return this.$t('free')
      const basketPrice = this.getTotalToPayWithoutDelivery
      if (delivery.freeAfter !== null && delivery.freeAfter < basketPrice) return this.$t('free')
      if (delivery.showWithMessage) return delivery.message
      if (delivery.price === 0) return this.$t('deliveries.accordingToTheCarrierTariffs')
      return Number(delivery.price).toFixed(2) + ' ' + this.$currency(this.currentRegionCurrency)
    },
    /**
     *
     * @param {DeliveryMethod} delivery
     * @return {string|null}
     */
    getDeliveryPriceToDisplay(delivery) {
      if (delivery.type === DeliveryType.PICKUP) return this.$t('free')
      const basketPrice = this.getTotalToPayWithoutDelivery
      if (delivery.freeAfter !== null && delivery.freeAfter < basketPrice) return this.$t('free')
      if (delivery.showWithMessage) return delivery.message
      if (delivery.price === 0) return this.$t('deliveries.accordingToTheCarrierTariffs')
      return Number(delivery.price).toFixed(2) + ' ' + this.$currency(this.currentRegionCurrency)
    },
    sendOrder() {
      if (this.isDistributor) {
        this.validateDistributor()
      } else {
        if (this.isOnlyProducts) {
          this.validateDeliveryMethod()
        } else {
          this.submit()
        }
      }
    },
    async submit() {
      debugger
      if (this.user?.bonusAmount < this.bonusesAmount) {
        return
      }
      this.$v.info.$touch()
      if (this.$v.info.$invalid) {
        console.log('Invalid', this.$v.info)
        return
      }

      /** @type {OrderCreatePayload} */
      const createOrderPayload = {
        hash: this.randomHash,
        order_type: this.selectedDocument,
      }

      this.generateOrderPayload(createOrderPayload)

      // for mocking order sending
      // this.showPopup();
      // console.log('order', createOrderPayload);
      // return;
      try {
        await this.checkOrder(createOrderPayload)
        if (!this.orderCheckResult.result) {
          this.showRemainingsPopup(true)
          return
        }

        const response = await this.createOrder(createOrderPayload)
        const transformedProducts = this.basket.map((product) => {
          return {
            item_id: product.select_type.article,
            item_name: product.title,
            affiliation: 'Renew-Cosmetics',
            coupon: '',
            discount: 0.0,
            index: 0,
            item_brand: product.brand?.data?.title || 'Renew',
            item_category: product.brandSeries?.data?.title || '',
            item_category2: (() => {
              if (!this.isAuthenticated) return 'unauthorized'
              if (this.isProfessional) return 'professional'
              if (this.isDistributor) return 'distributor'
              return 'regular'
            })(),
            item_list_id: 'Cosmetics',
            item_list_name: 'Cosmetics',
            location_id: 'ChIJIQBpAG2ahYAR_6128GcTUEo',
            price: product.select_type.price.toFixed(2),
            quantity: product.select_count,
          }
        })

        const sum = this.basket.reduce((acc, item) => {
          return acc + item.select_type.price.toFixed(2) * item.select_count
        }, 0)

        window.dataLayer.push({ ecommerce: null })
        window.dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: response.id,
            value: parseFloat(sum).toFixed(2),
            tax: 0.0,
            shipping: this.getDeliveryPrice,
            currency: this.currentRegionCurrency || 'EUR',
            coupon: this.promocode || '',
            items: transformedProducts,
          },
        })

        if (this.selectedPayment && this.selectedPayment.processType === PaymentProcessType.CARD_ONLINE) {
          await this.createInvoiceLocal()

          await this.resetBasket()

          return
        }
      } catch (error) {
        console.error(error)
        if (error.status === 422) {
          const objErrors = error.data.errors
          for (let i in objErrors) {
            objErrors[i].forEach((t) => {
              this.$toasted.error(t)
            })
          }
        } else {
          this.$toasted.error(error.data.message)
        }

        return
      }

      this.finishOrder()
    },
    finishOrder() {
      const handle = () => {
        this.showPopup()
        this.resetBasket()
      }
      this.$router
        .push({ name: 'main' })
        .then(() => setTimeout(handle, 1500))
        .catch(() => setTimeout(handle, 1500))

      this.$toasted.success(this.$t('successFastBuyCreate'))
    },
    generateOrderPayload(createOrderPayload, promocode = false) {
      if (this.promocode) {
        createOrderPayload['promocode'] = this.promocode
      }

      if (this.promocodeResponse) {
        createOrderPayload['order_id'] = this.promocodeResponse.order.id
      }

      if (this.zasilkovna.cityRef) createOrderPayload['city_ref'] = this.zasilkovna.cityRef
      if (this.zasilkovna.storeRef) createOrderPayload['store_ref'] = this.zasilkovna.storeRef
      if (this.zasilkovna.deliveryStore) createOrderPayload['delivery_store'] = this.zasilkovna.deliveryStore

      // console.log('this.zasilkovna ====>>>> ', this.zasilkovna);
      if (this.zasilkovna.countryRef) createOrderPayload['delivery_country'] = this.zasilkovna.countryRef
      if (this.zasilkovna.carrierRef) createOrderPayload['store_ref'] = this.zasilkovna.carrierRef

      if (this.selectedBonuses.pay_bonus_amount) {
        createOrderPayload.pay_bonus_amount = this.selectedBonuses.pay_bonus_amount
      }

      // if is distributor send org mode
      if (this.organization) {
        createOrderPayload.contact_legal_type = 'organisation'
        createOrderPayload.organisation_ico = this.organizationData.organisation_ico
        createOrderPayload.organisation_vat_number = this.organizationData.organisation_vat_number
      } else {
        createOrderPayload.contact_legal_type = 'private'
      }

      // products
      createOrderPayload.products = map(this.basket, (product) => ({
        id: product.id,
        product_price_id: product.select_type.id,
        count: product.select_count,
        is_present: product.isPresent || false,
        is_added_from_sale: product.isAddedFromSale || false,
      }))

      // user info
      createOrderPayload.name = this.info.name
      createOrderPayload.last_name = this.info.lastName
      createOrderPayload.phone = this.info.phone
      createOrderPayload.email = this.info.email
      createOrderPayload.additional_information = this.info.additionalInformation

      createOrderPayload.phone = createOrderPayload.phone.replace(/[^+\d]/g, '')
      createOrderPayload.phone_country = this.selectedCountry || 'cz'

      // payment
      if (this.certificate) {
        createOrderPayload.certificate = this.selectedCertificate
        if (!this.certificateFlag) {
          createOrderPayload.payment_method_id = this.selectedPayment.id
        }
      } else {
        if (this.selectedDocument !== OrderType.TRANSFER) {
          createOrderPayload.payment_method_id = this.selectedPayment.id
        }
      }

      // delivery
      if (!this.isDistributor || this.selectedDocument !== OrderType.CLIENTSALE) {
        createOrderPayload.delivery_method_id = this.selectedDelivery?.id
      }

      createOrderPayload.recipient = !!this.selectedRecipient.id
      createOrderPayload.recipient_first_name = this.payload.recipientName
      createOrderPayload.recipient_last_name = this.payload.recipientSecondName
      createOrderPayload.recipient_phone = this.payload.recipientPhone
      createOrderPayload.need_confirm = !this.do_not_callback

      if (this.isProfessional || this.isDistributor) {
        createOrderPayload.only_webinars = this.isOnlyWebinars
        createOrderPayload.goes_to_patient = this.goes_to_patient
      }
      if (this.canSelectAddress(this.selectedDelivery)) {
        if (this.selectedAddressFromList) {
          createOrderPayload.address = {
            guid: this.dataFromAddressesList.guid,
            contact: this.dataFromAddressesList.contact,
          }
        } else {
          const needFullAddress = [DeliveryType.ADDRESS, DeliveryType.COURIER, DeliveryType.COURIER_PRAHA, DeliveryType.CARRIER]

          const setAddressDetails = () => {
            if (!promocode && this.selectedDelivery.type === DeliveryType.CARRIER) {
              createOrderPayload.delivery_country = this.deliveryAddress.countryCode
              createOrderPayload.store_ref = this.deliveryAddress.carrierRef
              createOrderPayload.carrier_pickup_point = this.deliveryAddress.pickupPointRef
            } else if (!promocode) {
              createOrderPayload.delivery_city = this.addressNovaPoshtaCourier.city || this.deliveryAddress.city
              createOrderPayload.delivery_street = this.addressNovaPoshtaCourier.street
              createOrderPayload.delivery_building = this.addressNovaPoshtaCourier.building
              createOrderPayload.delivery_apt = this.addressNovaPoshtaCourier.flat
              createOrderPayload.delivery_zip = this.addressNovaPoshtaCourier.zip
              createOrderPayload.delivery_user_address = [
                `city ${createOrderPayload.delivery_city}`,
                `street ${this.addressNovaPoshtaCourier.street}`,
                `building ${this.addressNovaPoshtaCourier.building}`,
                `apt. ${this.addressNovaPoshtaCourier.flat}`,
                `zip. ${this.addressNovaPoshtaCourier.zip}`,
              ].join(', ')
              createOrderPayload.delivery_carrier = this.deliveryAddress.carrier
              createOrderPayload.store_ref = this.addressNovaPoshtaCourier.carrierRef
              createOrderPayload.delivery_country = this.addressNovaPoshtaCourier.country
              createOrderPayload.carrier_pickup_point = this.addressNovaPoshtaCourier.pickupPointRef
            }
          }

          const setStoreDetails = () => {
            if (!promocode) {
              createOrderPayload.delivery_city = this.addressNovaPoshta.city || this.deliveryAddress.city
              createOrderPayload.delivery_store = this.addressNovaPoshta.department || this.deliveryAddress.department
              createOrderPayload.delivery_user_address = [
                `city ${createOrderPayload.delivery_city}`,
                `${createOrderPayload.delivery_store}`,
                `zip. ${this.addressNovaPoshtaCourier.zip}`,
              ].join(', ')
            }
          }

          if (!this.isDistributor || this.selectedDocument !== OrderType.CLIENTSALE) {
            if (needFullAddress.includes(this.selectedDelivery.type)) {
              setAddressDetails()
            } else if (this.selectedDelivery.type === DeliveryType.STORAGE && this.isOnlyProducts) {
              setStoreDetails()
            }
          }
        }
      }
    },

    fetchOrderPromotion: debounce(async function () {
      {
        /** @type {OrderCreatePayload} */
        const orderPayload = {
          hash: this.randomHash,
          order_type: this.selectedDocument,
        }
        this.generateOrderPayload(orderPayload, true)
        try {
          const response = await this.fetchPromotion(orderPayload)
          this.promotionResponse = response
          this.promotionProducts = response.order.orderProducts.data
        } catch (e) {
        } finally {
          this.isPriceLoading = false
        }
      }
    }, 1000),
    async activatePromocode() {
      this.$v.$touch()
      if (this.$v.info.$invalid) return

      this.loadingPromoCode = true
      try {
        /** @type {OrderCreatePayload} */
        const orderPayload = {
          hash: this.randomHash,
          order_type: this.selectedDocument,
        }
        this.generateOrderPayload(orderPayload, true)

        const response = await this.fetchPromocodeInfo(orderPayload)
        const ids = map(this.basket, 'id')
        if (response.promocode.activated) {
          this.promocodeActivated = response.promocode.activated
          this.promocodeProducts = response.order.orderProducts.data
          this.promocodeResponse = response
          this.$toasted.success(this.$t('promocodeSuccessActivated'))
        } else {
          this.promocodeActivated = response.promocode.activated
          this.$toasted.error('Недійсний промокод')
        }
        await this.fetchDefaultPrices({ ids: ids })
      } catch (e) {
        if (e.status === 422) {
          this.validationErrors = e.data.errors
        }
      } finally {
        this.loadingPromoCode = false
      }
    },
    showPopup() {
      const popupSettings = {
        withSms: this.selectedPayment?.processType === PaymentProcessType.PAY_WITH_DETAILS,
        notCall: this.do_not_callback,
        withWebinar: this.isAwebinar,
      }

      if (this.isDistributor) {
        popupSettings.documentType = this.selectedDocument
      }

      this.changeSuccessPayment({ status: true, payload: popupSettings })
    },
    isMobile() {
      return isMobile.any() || isIPad.iOS()
    },
  },
}
